import { cn } from "@/lib/cn";

/**
 * Standalone progress indicator (for embedded use). The presentation mode has
 * its own integrated indicator inside PresentationFrame.
 */
export const ProgressIndicator = ({
  value = 0,
  className,
  testId,
  label,
}) => {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div
      data-testid={testId || "progress-indicator"}
      className={cn("flex flex-col gap-1.5", className)}
    >
      {label && (
        <div className="flex items-center justify-between text-xs text-muted-foreground">
          <span>{label}</span>
          <span className="font-mono tabular-nums">{Math.round(pct)}%</span>
        </div>
      )}
      <div className="h-1 w-full overflow-hidden rounded-full bg-surface">
        <div
          className="h-full bg-brand transition-[width] duration-500 ease-out-expo"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressIndicator;
